import { gql } from '@apollo/client';

export const GET_BLOCKED_USERS = gql`
  query GetBlockedUsers {
    getBlockedUsers {
      _id
      username
      firstName
      lastName
      blockedAt
    }
  }
`;
